<template>
  <div class="mt-5">
    <h5 class="section-container text-center pt-3">
      <strong>POST</strong>
    </h5>
    <div class="col-12 px-0 border-bottom">
      <scale-question
        :id="postQuestion.id"
        v-model="selectedNumericAnswer"
        :number-label="postQuestion.numberLabel"
        :text="postQuestion.text"
        :scales="answerNumerals"
        :disabled="disabled"
        @onSelectedNumericAnswer="onNumericAnswerChanged"
      />
    </div>
    <div class="row">
      <div class="col-md-12 ml-5 mt-3">
        <strong>Evidencia para {{ postQuestion.numberLabel }}</strong>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ml-5">
        <div class="row">
          <div class="col-md-2 col-sm-12">
            <ValidationProvider
              v-slot="{ errors }"
              mode="eager"
              name="Answer"
              rules="required"
            >
              <CustomDropDown
                v-model="sourceYesOrNoAnswer"
                label
                required
                placeholder="Seleccionar"
                fieldkey="id"
                fieldname="text"
                :disabled="disabled"
                :options="postQuestion.answers"
                :error="errors[0]"
                :custom-error-msg="errorMsgs.answer"
                @input="onYesOrNoChanged"
              />
            </ValidationProvider>
          </div>
        </div>
        <div v-if="showTextarea" class="row">
          <div class="col-md-6 col-sm-12">
            <div class="additional-questions-item">
              <strong>Resumen de resultados relevantes:</strong>
              <div class="form-group">
                <div class="input-group mb-3">
                  <ValidationProvider
                    v-slot="{ errors }"
                    mode="eager"
                    name="resumen"
                    rules="required"
                    style="width:100%"
                  >
                    <CustomTextArea
                      v-show="true"
                      :id="'summaryRelevantsResults'"
                      v-model="postQuestion.evidenceNote"
                      :error="errors[0]"
                      :custom-error-msg="errors[0] + '.'"
                      style="width:100%"
                      :maxlength="maxchars"
                      :classes="['eq-field']"
                      :disabled="disabled"
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped src="@/assets/css/component/radio-button.css"></style>
<style scoped>
h1 {
  font-weight: bold;
  font-size: 1.2em;
}
.main-container-for-pre {
  margin-bottom: 5px;
}
.section-container {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
  height: 59px;
}
</style>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomTextArea from '@/components/common/CustomTextArea';
import ScaleQuestion from '@/components/pei/evaluations/serviceintervention/components/ScaleQuestion';
import yesOrNotEnum from '@/utils/constants/yesOrNotEnum';

export default {
  name: 'PostQuestion',
  components: {
    CustomDropDown,
    CustomTextArea,
    ValidationProvider,
    ScaleQuestion,
  },
  filters: {
    extractNumber(value) {
      return value.slice(0, 1);
    },
    extractLetter(value) {
      function evalLetter(letter) {
        switch (letter) {
          case 'a':
            return '1';
          case 'b':
            return '2';
          case 'c':
            return '3';
          default:
            return '';
        }
      }
      let letter = value.slice(2, value.length - 1);
      let n = evalLetter(letter);
      return n;
    },
  },
  data() {
    return {
      selectedNumericAnswer: this.getNumericAnswer(),
      sourceYesOrNoAnswer: this.getYesOrNoAnswer(),
      maxchars: 500,
      errorMsgs: {
        answer: 'Se requiere de una respuesta para continuar.',
      },
      disabledDates: {
        from: new Date(),
      },
    };
  },
  computed: {
    showTextarea() {
      return this.sourceYesOrNoAnswer?.id === yesOrNotEnum.yes;
    },
  },
  props: {
    answerNumerals: {
      type: Array,
      default: () => [],
    },
    postQuestion: {
      type: Object,
      default: () => {},
    },
    evidences: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    getNumericAnswer() {
      let selectedNumericValue = this.answerNumerals.find(
        (x) => x.id == this.postQuestion.questionnaireAnswerId
      );
      const result = {
        id: selectedNumericValue != undefined ? selectedNumericValue.id : 0,
        text: selectedNumericValue != undefined ? selectedNumericValue.text : 0,
      };

      return result.id > 0 ? result : null;
    },
    getYesOrNoAnswer() {
      let selectedNumericValue = this.postQuestion.answers.find(
        (x) => x.id == this.postQuestion.evidenceAvailable
      );
      const result = {
        id:
          this.postQuestion.evidenceAvailable != null
            ? this.postQuestion.evidenceAvailable
            : 0,
        text:
          selectedNumericValue != undefined ? selectedNumericValue.text : '',
      };

      return result.id > 0 ? result : null;
    },
    onYesOrNoChanged(data) {
      this.postQuestion.evidenceAvailable = data.id;
    },
    onNumericAnswerChanged(answerId) {
      if (answerId > 0) {
        this.postQuestion.questionnaireAnswerId = answerId;
        this.postQuestion.answerNumericValue = Number(
          this.answerNumerals.find((x) => x.id == answerId).text
        );
      }
    },
  },
};
</script>
